var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"board-card",attrs:{"to":{name:'board', params:{name: _vm.name, id: _vm.id}}}},[_c('span',{staticClass:"board-card-title"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }